import { m } from 'framer-motion';
import { graphql, PageProps } from 'gatsby'
import { getImage, GatsbyImage} from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next";

import Link from '../components/Atoms/Link';
import Layout from '../components/layout'
import Seo from '../components/seo'

const NotFoundPage = ({data}: PageProps<Queries.NotFoundPageQuery>) => {
  const { t } = useTranslation();

  return (
    <Layout hideFooter>
      <Seo title="404: Not found" />
      <div className="flex flex-col lg:flex-row w-screen h-screen bg-blue items-center justify-center mt-10">
        <div className="flex flex-col">
          <h1 className="font-cirka text-6xl text-gray-400 mb-12">Error 404</h1>
          <p className="text-lg text-gray-400 mb-8">{t('error404.text')}</p>
          <Link to="/" className="text-lg text-primary">{t('error404.back')}</Link>
        </div>
        <m.div
          initial={{ opacity: 0}}
          animate={{ opacity: 1}}
        >
          <GatsbyImage image={getImage(data.image404)} alt="error 404" className="items-center justify-center h-auto" />
        </m.div>
      </div>
    </Layout>
  )
}

export default NotFoundPage;

export const query = graphql`
  query NotFoundPage($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }

    image404: file(base: {eq: "404.jpg"}) {
      base
      childImageSharp {
        gatsbyImageData(
          width: 800
          placeholder: DOMINANT_COLOR
          formats: AUTO
        )
      }
    }
  }
`;
